/** Préférence "Lancer automatiquement" — persistée entre sessions (comme le thème). */
export const AUTO_ROLL_STORAGE_KEY = 'multirx-dice-auto-roll';

export function readAutoRollPreference(storage: Pick<Storage, 'getItem'> = localStorage): boolean {
  return storage.getItem(AUTO_ROLL_STORAGE_KEY) === '1';
}

export function writeAutoRollPreference(
  enabled: boolean,
  storage: Pick<Storage, 'setItem'> = localStorage
): void {
  storage.setItem(AUTO_ROLL_STORAGE_KEY, enabled ? '1' : '0');
}

/**
 * Aligne le checkbox UI sur le storage (source de vérité).
 * Évite le softlock où localStorage=1 mais la case est décochée → plus aucun lancer Auto.
 */
export function syncAutoRollCheckbox(
  checkbox: HTMLInputElement | null | undefined,
  storage: Pick<Storage, 'getItem'> = localStorage
): boolean {
  const wanted = readAutoRollPreference(storage);
  if (checkbox && checkbox.checked !== wanted) {
    checkbox.checked = wanted;
  }
  return wanted;
}

/** True si Auto doit lancer — resync checkbox avant lecture. */
export function isAutoRollEnabled(
  checkbox: HTMLInputElement | null | undefined,
  storage: Pick<Storage, 'getItem'> = localStorage
): boolean {
  return syncAutoRollCheckbox(checkbox, storage);
}
